export const VOL_SMILE_TENORS_KEYS = [
  '5P',
  '10P',
  '15P',
  '20P',
  '25P',
  '30P',
  '35P',
  '40P',
  'DN',
  '40C',
  '35C',
  '30C',
  '25C',
  '20C',
  '15C',
  '10C',
  '5C',
];

export const VOL_SMILE_PERIOD_KEYS = ['1W', '2W', '1M', '3M', '6M', '9M'];

export const VOL_SMILE_TENORS_WITH_ATMF_KEYS = VOL_SMILE_TENORS_KEYS.map((key) =>
  key === 'DN' ? 'ATMF' : key,
);
